interface PhotographyIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const PhotographyIcon = (props: PhotographyIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path
        style={{ fill: fillColor }}
        d="M26.6,15.9c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8S27.1,15.9,26.6,15.9z M20,17.1
            c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3S21.8,17.1,20,17.1z M20,22.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5
            s2.5,1.1,2.5,2.5S21.4,22.9,20,22.9z M29.9,13.8h-3.3c-1.7,0-2.5-2.5-4.1-2.5c-1.7,0-2.5,0-2.5,0s-0.8,0-2.5,0s-2.5,2.5-4.1,2.5
            h-3.3c-0.9,0-1.7,0.7-1.7,1.7V27c0,0.9,0.7,1.7,1.7,1.7h19.8c0.9,0,1.7-0.7,1.7-1.7V15.5C31.6,14.5,30.8,13.8,29.9,13.8z M30.7,27
            c0,0.5-0.4,0.8-0.8,0.8H10.1c-0.5,0-0.8-0.4-0.8-0.8V15.5c0-0.5,0.4-0.8,0.8-0.8h3.1h0.2c2.1,0,2.9-2.5,4.1-2.5c1.2,0,2.5,0,2.5,0
            s1.3,0,2.5,0c1.3,0,2.1,2.5,4.2,2.5H27h2.9c0.5,0,0.8,0.4,0.8,0.8V27z M20,15.5c-2.7,0-5,2.2-5,5c0,2.7,2.2,5,5,5s5-2.2,5-5
            C25,17.7,22.7,15.5,20,15.5z M20,24.5c-2.3,0-4.1-1.8-4.1-4.1c0-2.3,1.8-4.1,4.1-4.1s4.1,1.8,4.1,4.1C24.1,22.7,22.3,24.5,20,24.5z
            "
      />
    </svg>
  )
}

export default PhotographyIcon
